export default {
  resourcesAmountEmpty: 'Se autocompletará al agregar recursos',
  durationAmountEmpty: 'Se autocompletará al agregar recursos',
  agesPlaceholder: 'Elige hasta 2 edades',
  ageRangeLabel: 'Edades',
  agesInfoTitle: 'Edades',
  agesInfo: 'Selecciona las edades del alumnado al que está destinado tu {content}.',
  evaluationMethod: 'Tipo de evaluación',
  evaluationMethodPlaceholder: 'Selecciona una técnica'
}

export const en = {
  resourcesAmountEmpty: 'Will autocomplete when adding resources',
  durationAmountEmpty: 'Will autocomplete when adding resources',
  agesPlaceholder: 'Choose up to 2 ages',
  ageRangeLabel: 'Ages',
  agesInfoTitle: 'Ages',
  agesInfo: 'Select the ages of the students for whom your {content} is intended.',
  evaluationMethod: 'Evaluation Type',
  evaluationMethodPlaceholder: 'Select a technique'
}

export const ca = {
  resourcesAmountEmpty: 'S\'autocompletarà en agregar recursos',
  durationAmountEmpty: 'S\'autocompletarà en agregar recursos',
  agesPlaceholder: 'Tria fins a 2 edats',
  ageRangeLabel: 'Edats',
  agesInfoTitle: 'Edats',
  agesInfo: 'Selecciona les edats de l\'alumnat al qual està destinat el teu {content}.',
  evaluationMethod: 'Tipus d\'avaluació',
  evaluationMethodPlaceholder: 'Seleccioneu una tècnica'
}
